import { useGetUser } from '@web/api/users/use-get-user';
import { useIsAuthenticated } from '@web/auth/use-is-authenticated';

export function useSelectCompanyInfo() {
  const isAuthenticated = useIsAuthenticated();
  const { data: user } = useGetUser({
    enabled: isAuthenticated,
  });
  const entities = user?.companies;
  const defaultEntityId = user?.defaultCompanyId;
  return { entities, defaultEntityId };
}
